import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes__default from 'prop-types';
import { Box, Container, Grid, Typography, Link } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import SvgDownloadBottom from '../../common/streamlinehq/img/streamline-regular/internet-networks-servers/upload-download/download-bottom.svg.js';
import StreamlineIcon from '../../widgets/streamline-icon/StreamlineIcon.js';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';

var useStyles = makeStyles(function (theme) {
  return {
    downloadArea: {
      border: "1px dashed ".concat(theme.palette.grey[200]),
      borderRadius: theme.spacing(3),
      maxWidth: theme.spacing(35),
      position: "relative"
    },
    downloadBtn: {
      position: "absolute",
      top: 0,
      right: 0,
      width: theme.spacing(7),
      height: theme.spacing(7),
      borderLeft: "1px dashed ".concat(theme.palette.grey[200]),
      borderBottom: "1px dashed ".concat(theme.palette.grey[200]),
      borderRadius: theme.spacing(0, 3),
      cursor: "pointer"
    },
    link: {
      fontSize: theme.spacing(2),
      color: theme.palette.grey[800]
    }
  };
});
var PdfDownloads = function PdfDownloads(_ref) {
  var _pdfDocs$2, _pdfDocs$3, _pdfDocs$4, _downloadBtn$fields2, _downloadBtn$fields3;
  var bgColor = _ref.bgColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    pdfDocs = _ref.pdfDocs,
    downloadBtn = _ref.downloadBtn;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var getButtonLink = function getButtonLink() {
    var _downloadBtn$fields, _pdfDocs$;
    return downloadBtn !== null && downloadBtn !== void 0 && (_downloadBtn$fields = downloadBtn.fields) !== null && _downloadBtn$fields !== void 0 && _downloadBtn$fields.url ? downloadBtn.fields.url : (_pdfDocs$ = pdfDocs[0]) === null || _pdfDocs$ === void 0 || (_pdfDocs$ = _pdfDocs$.pdfDocument) === null || _pdfDocs$ === void 0 || (_pdfDocs$ = _pdfDocs$.file) === null || _pdfDocs$ === void 0 ? void 0 : _pdfDocs$.url;
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    pt: isExtraSmallScreen() ? 8 : 9,
    pb: 10,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    sm: 6,
    xs: 12
  }, title && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3"
  }, title)), pdfDocs && /*#__PURE__*/React__default.createElement(Box, {
    mt: 2,
    px: 4,
    py: 3,
    className: classes.downloadArea
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    className: classes.downloadBtn
  }, /*#__PURE__*/React__default.createElement(Link, {
    href: (_pdfDocs$2 = pdfDocs[0]) === null || _pdfDocs$2 === void 0 || (_pdfDocs$2 = _pdfDocs$2.pdfDocument) === null || _pdfDocs$2 === void 0 || (_pdfDocs$2 = _pdfDocs$2.file) === null || _pdfDocs$2 === void 0 ? void 0 : _pdfDocs$2.url,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(StreamlineIcon, null, /*#__PURE__*/React__default.createElement(SvgDownloadBottom, null)))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 1
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "div"
  }, (_pdfDocs$3 = pdfDocs[0]) === null || _pdfDocs$3 === void 0 || (_pdfDocs$3 = _pdfDocs$3.pdfDocument) === null || _pdfDocs$3 === void 0 ? void 0 : _pdfDocs$3.title), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, (_pdfDocs$4 = pdfDocs[0]) === null || _pdfDocs$4 === void 0 || (_pdfDocs$4 = _pdfDocs$4.pdfDocument) === null || _pdfDocs$4 === void 0 ? void 0 : _pdfDocs$4.description)), downloadBtn && /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(CustomButton, {
    href: getButtonLink(),
    target: "_blank",
    color: downloadBtn === null || downloadBtn === void 0 || (_downloadBtn$fields2 = downloadBtn.fields) === null || _downloadBtn$fields2 === void 0 || (_downloadBtn$fields2 = _downloadBtn$fields2.type) === null || _downloadBtn$fields2 === void 0 ? void 0 : _downloadBtn$fields2.toLowerCase(),
    variant: "contained"
  }, downloadBtn === null || downloadBtn === void 0 || (_downloadBtn$fields3 = downloadBtn.fields) === null || _downloadBtn$fields3 === void 0 ? void 0 : _downloadBtn$fields3.label)))), !isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3"
  }, subtitle)), pdfDocs === null || pdfDocs === void 0 ? void 0 : pdfDocs.filter(function (item, index) {
    return index !== 0;
  }).map(function (doc, index) {
    var _doc$pdfDocument, _doc$pdfDocument2;
    return /*#__PURE__*/React__default.createElement(Box, {
      mt: 2,
      key: index
    }, (doc === null || doc === void 0 ? void 0 : doc.slug) && /*#__PURE__*/React__default.createElement(Link, {
      href: doc === null || doc === void 0 || (_doc$pdfDocument = doc.pdfDocument) === null || _doc$pdfDocument === void 0 || (_doc$pdfDocument = _doc$pdfDocument.file) === null || _doc$pdfDocument === void 0 ? void 0 : _doc$pdfDocument.url,
      underline: "always",
      className: classes.link,
      target: "_blank"
    }, doc === null || doc === void 0 || (_doc$pdfDocument2 = doc.pdfDocument) === null || _doc$pdfDocument2 === void 0 ? void 0 : _doc$pdfDocument2.title));
  })))));
};
PdfDownloads.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  pdfDocs: PropTypes__default.array,
  downloadBtn: PropTypes__default.object
};

export { PdfDownloads as default };
//# sourceMappingURL=PdfDownloads.js.map
